import { Model } from '@bryntum/scheduler';

export default class OrderLineItemModel extends Model {
    static get $name() {
        return 'OrderLineItemModel';
    }

    static get fields() {
        return [
            'id',
            'orderId',
            'lineItemId',
            'equipmentTypeId',
            'equipmentTypeType',
            'pricingMethodType',
            'orderBy',
            'loadOrQuantityReq',
            'price',
            'equipmentRequired',
            'quoteLineItemDriverMemo',
            'memo',
            'driverMemo',
            'dispatchMemo',
            'arrivalTime',
            'yardTime',
            'onsiteTime',
            'orderNumber',
            'jobNumber',
            'name',
            'orderLineItemNumber',
            'jobId',
            'isScheduled',
            'requirements',
            'poNumber',
            'haulToAddressLine1',
            'haulToAddressLine2',
            'haulToCity',
            'haulToState',
            'haulToZipCode',
            'haulToCountry',
            'haulToDirections',
            'haulFromAddressLine1',
            'haulFromAddressLine2',
            'haulFromCity',
            'haulFromState',
            'haulFromZipCode',
            'haulFromCountry',
            'haulFromDirections',
            'haulToSiteName',
            'haulToRegion',
            'haulToRegionId',
            'haulFromSiteName',
            'haulFromRegion',
            'haulFromRegionId',
            'canceledOn',
            'cancellationReason',
            'canceledByUserId',
            'isCancelable',
            'isOrderInReview',
            'customerName',
            'siteName',
            'regionName',
            'orderer',
            'dispatchingIntervalTimeFormatted',
            'intervalCount',
            'projectName',
            'jobName',
            'yardTimeFormatted',
            'onsiteTimeFormatted',
            'cls'
        ];
    }

    static get defaults() {
        return {
            durationUnit: 'h',

            name: 'New event',
        };
    }
}
